export default "__VITE_ASSET__BWhs$7B2__"